import { IconName } from "@/wc/components";

type StudentQuote = {
  name: string;
  imgUrl: string;
  icon: IconName;
  quote: string;
};

export const StudentQuotes: StudentQuote[] = [
  {
    name: "Brandi Jones",
    icon: "usa",
    imgUrl: "/static/images/student/avatar-2.jpg",
    quote:
      "These projects are amazing and have helped me as a newbie entering the AWS Cloud field...I wish my previous career provided FREE resources like this.",
  },
  {
    name: "Abdulrahman Sulaiman",
    icon: "ng",
    imgUrl: "/static/images/student/avatar-4.jpg",
    quote:
      "I am super excited and happy that I am building projects through NextWork which exposes me to how its been done in the real world... I am never leaving NextWork... I really wished I'd joined earlier. NextWork is making me a superstar!!!🕺",
  },
  {
    name: "Lelo Mndebele",
    icon: "za",
    imgUrl: "/static/images/student/avatar-0.jpg",
    quote:
      "This is by far the most well structure projects platform I've ever experienced, even better it caters for different learning experiences. Where some platforms will expect you to already know the basics and troubleshoot your own errors. I love these projects and I'll be linking them to my resume most definitely!",
  },
  {
    name: "Arina Bolotbekova",
    icon: "kg",
    imgUrl: "/static/images/student/avatar-1.jpg",
    quote: "NextWork is a new vision on education...they've turned learning into an exciting experience.",
  },
  {
    name: "Denzel Manalo",
    icon: "ph",
    imgUrl: "/static/images/student/avatar-3.jpg",
    quote:
      "NextWork is the only community that has provided me with actual projects to create and learn from, and because of that I'm now interested in becoming a DevOps engineer in the future.",
  },
  {
    name: "Mujtabaa Suliman",
    icon: "za",
    imgUrl: "/static/images/student/avatar-5.jpg",
    quote:
      "Really appreciate the effort the team put into creating a course that makes it easy to learn. They have somehow perfected a way that makes you interested without getting bored. They should be creating university courses honestly!",
  },
];
